import React, { Component } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import Constant from "../../../Constant";
import BarLoader from "react-bar-loader";

export default class Conferences extends Component {
  state = {
    loading: true,
    data: [],
    columns: [
      {
        name: "Image",
        selector: "image",
        sortable: true,
        width: "100px",
        cell: (row) => (
          <img
            src={
              row.image !== ""
                ? row.image
                : "./images/homepage/placeholder-img.jpg"
            }
            alt=""
            className="image_square py-2"
            onError={(e) => {
              e.target.src =
                "./images/homepage/placeholder-img.jpg";
            }}
          />
        ),
      },
      {
        name: "Topic Name",
        selector: "name",
        sortable: true,
      },
      {
        name: "Topic Type",
        selector: "contentType",
        sortable: true,
      },
      {
        name: "Options",
        selector: "year",
        sortable: true,
        cell: (row) => (
          <div className="d-flex">
            <Link
              to={`/admin/edit-topic/${this.props.match.params.course_id}&${row.id}`}
            >
              <i
                class=" btn btn-light shadow-sm mx-1 fas fa-pencil-alt text-primary"
                id={row.id}
              ></i>
            </Link>
            <i
              class="btn btn-light shadow-sm mx-1 fas fa-times text-danger"
              id={row.id}
              onClick={this.deleteTopic}
            ></i>

            <Link
              to={`/admin/view-topic/${this.props.match.params.course_id}&${row.id}`}
            >
              <i
                class="btn btn-light shadow-sm mx-1 fas fa-share text-dark"
                id={row.id}
              ></i>
            </Link>
          </div>
        ),
      },
    ],
  };

  componentDidMount() {
    this.setState({
      loading: !this.state.loading,
    });
  }

  render() {
    return (
      <div>
        <div className="py-3">
          <div className="container border shadow-sm p-0 bg-white">
            <div className="header bg-primary text-white">
              <div className="row m-0">
                <div className="col-md-6 p-3 d-flex align-items-center">
                  <h5 className="m-0">
                    <Link to="/trainer/dashboard">Home</Link> /{" "}
                    <Link to="/trainer/conferences">Conference</Link>
                  </h5>
                </div>
                <div className="col-md-6 d-flex justify-content-end align-items-center">
                  <Link
                    to={`/trainer/add-conferences`}
                    className="btn btn-dark float-right"
                  >
                    Add Conference
                  </Link>
                </div>
              </div>
            </div>

            {/* <div className="row float-right">
              <div class="form-group row">
                <label for="from" class="col-sm-2 col-form-label">
                  From
                </label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    className="form-control"
                    id="from"
                    placeholder="DD/MM/YYYY"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="to" class="col-sm-2 col-form-label">
                  To
                </label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    className="form-control"
                    id="to"
                    placeholder="DD/MM/YYYY"
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-10">
                  <button type="text" className="btn btn-primary" id="to">
                    Search
                  </button>
                </div>
              </div>
            </div> */}

            <div className="users-container p-2">
              {this.state.loading == true ? (
                <div className="container p-5">
                  <div className="col-md-3 mx-auto">
                    <BarLoader color="#33cabb" height="4" />
                  </div>
                </div>
              ) : (
                <DataTable
                  noHeader={true}
                  columns={this.state.columns}
                  data={this.state.topics}
                  theme="solarized"
                  pagination={true}
                  noDataComponent={
                    <div className="m-3">No Topics Available</div>
                  }
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
